import type { PurchaseOrder } from "@shared/types";
import { CellContext } from "@tanstack/react-table";
import { parseISO } from "date-fns";
import { useTranslation } from "react-i18next";

export const OrderCreatedAtCell = (props: CellContext<PurchaseOrder, unknown>) => {
  const { t } = useTranslation();
  const createdAt = parseISO(props.row.original.createdAt);

  if (props.row.subRows.length > 0) {
    return <>{t("dates.short", { date: createdAt })}</>;
  }

  return <span className="text-sm text-foreground font-medium">{t("dates.relative", { date: createdAt })}</span>;
};
